const state = {
    SelectedNotams : []

};

const mutations = {
    set_favNotam_data(state, payload) {

        state.SelectedNotams.push(payload);

    },

};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
